import React, { useEffect, useState } from 'react';
import { usePage } from '@inertiajs/react';
import {hexToRgba} from "@Utils/Helpers";
import {LoginProps} from "@Pages/Auth/Login/LoginType";
import {NO, YES} from "@Types/ApplicationConstants";
import {ProgressBar} from "primereact/progressbar";
import { Footer }  from "@Components/Footer";
import JMSBackground from "@Assets/domain/background/jms-background.jpeg";
import AppProvider from "@Utils/AppProvider";
import {ToastWrap} from "@Components/ToastWrap";

export default function GuestLayout({ children, branding }: { children: React.ReactNode, branding: string }) {
  const { settings } = usePage().props as LoginProps;
  const { sso, primaryColor } = settings;
  const isAlinta = branding === "ALINTA";

  const [showProgressBar, setShowProgressBar] = useState<string>(NO);
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      setShowProgressBar(event.persisted ? YES : NO);
      if (event.persisted) {
        location.reload();
      }
    };

    // popstate
    window.addEventListener('pageshow', handlePageShow);
    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  });

  if (showProgressBar === YES) {
    return <ProgressBar mode="indeterminate" style={{height: '6px'}}/>;
  }

  const backgroundStyle = {
    backgroundImage: `url(${import.meta.env.VITE_LOGIN_SCREEN_BACKGROUND ? new URL(import.meta.env.VITE_LOGIN_SCREEN_BACKGROUND, import.meta.url).href : JMSBackground})`,
    backgroundColor: primaryColor || 'white',
  }
  const footerStyle = {
    background: !sso ? 'linear-gradient(49.69deg, #0A304C 8.36%, #017E65 83.25%)' : `${hexToRgba(primaryColor, 0.8)}`,
    borderTop: !sso ? '2px solid #76C54D' : '1px solid white',
    color: 'white',
  }

  return (
    <AppProvider>
      <ToastWrap />
        <div className="grid m-0 p-0" style={{height: '100vh'}}>
        {!isAlinta ? (
          <div
            className="pages-body login-page flex flex-column relative w-full"
            style={backgroundStyle}
          >
            {children}
            <div className="layout-footer flex justify-content-between p-4 shadow-2" style={footerStyle}>
              <Footer branding={branding}/>
            </div>
          </div>
        ) : (
          <>
            <div
              className="pages-body login-page flex flex-column hidden md:block md:col-7 h-full"
              style={backgroundStyle}
            />
            <div className="col-12 md:col-5 m-0 p-0">
              {children}
              <div className="mt-auto absolute left-0 bottom-0 flex text-black md:text-white md:col-7 col-12 footer-gradient-orange h-8rem left-0 z-5 text-xl">
                <Footer branding={branding}/>
              </div>
            </div>
          </>
        )
        }
      </div>
    </AppProvider>
  );
}


